export default __webpack_public_path__ + "static/media/cv_mask.eab58de5.svg";